import { ladeBausteine, ladeStationsbausteine } from '../../persistence/bausteine';
import type { Store } from '../../persistence/port';
import type { SnippetNode } from '../../domain/types';
import type { LogScope } from '../../platform/storage';

/**
 * Die Bausteine für dieses Kommentarblatt — je nach Bezug aus der Aufgabe oder aus der Station.
 *
 * ⭐ **Bis zum 2026-09-20 gab es hier nichts zu entscheiden.** Bausteine hingen nur an der
 * Aufgabe, und im Blatt stand: „Beim Stationskommentar zeigt `task.id` ins Leere — dort gibt es
 * keine Aufgabe und damit keine Bausteine." Die Relay-Seite hat das berichtigt: die Station
 * führt eine eigene Liste (`ExamItemContainer.textBlockContainerID`), und der Auftrag des
 * Nutzers vom 2026-09-18 lautete ausdrücklich „zuordenbar zu Station **und** Aufgabe".
 *
 * ⚠️ **Die Kennung ist dieselbe Stelle, aber nicht dasselbe Ding.** Beim Stationskommentar
 * formt `app/App.tsx` die Station als Aufgabe (`alsAufgabe`), `task.id` ist dort also die
 * **Stationskennung**. Nur der Bezug sagt, welche Tabelle gemeint ist.
 */
export function bausteineFuer(store: Store, bezug: LogScope, id: string): Promise<SnippetNode[]> {
  return bezug === 'station-comment' ? ladeStationsbausteine(store, id) : ladeBausteine(store, id);
}
